// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2OnwR","errorLogs":"styles_errorLogs__2V3qB"};